<i18n>
{
	"en": {
		"freeText": "Free text",
		"noFreeText": "There are no free texts yet.",
		"invoice": "Invoice",
		"waybill": "Waybill",
		"loadingList": "Loading list",
		"internal": "Internal",
		"goodsList": "Goods list"
	},
	"no": {
		"freeText": "Fritekst",
		"noFreeText": "Det er ingen fritekster ennå.",
		"invoice": "Faktura",
		"waybill": "Fraktbrev",
		"loadingList": "Lasteliste",
		"internal": "Internt",
		"goodsList": "Godsliste"
	}
}
</i18n>

<template>
	<div class="free-text-sub-order">

		<MultipleTextAreas
			:textAreas="textAreas"
			textAreaKeyToFocus="invoice"
			:disabled="orderIsLocked"

			@textAreaChange="setFreeText({ key: $event.key, freeText: $event.value })"
		/>
	</div>
</template>

<script>
import {
	mapState, mapMutations, mapGetters
} from '../store/newOrder.store';
import MultipleTextAreas from '@/modules/newOrder/common/MultipleTextAreas';

export default {
	name: 'FreeText',
	components: { MultipleTextAreas },
	computed: {
		...mapState(['order']),
		...mapGetters(['orderIsLocked']),

		textAreas() {
			return [
				{
					key: 'transporterInstructions',
					value: this.order.transporterInstructions,
					name: this.$t('waybill')
				},
				{
					key: 'invoiceFreeText',
					value: this.order.invoiceFreeText,
					name: this.$t('invoice')
				},
				{
					key: 'loadingListFreeText',
					value: this.order.loadingListFreeText,
					name: this.$t('loadingList')
				},
				{
					key: 'internalNotes',
					value: this.order.internalNotes,
					name: this.$t('internal')
				},
				{
					key: 'goodsListFreeText',
					value: this.order.goodsListFreeText,
					name: this.$t('goodsList')
				}
			];
		},
	},
	methods: {
		...mapMutations(['setFreeText']),
	}
};
</script>

<style lang="scss" scoped>

.free-text-sub-order {
	height: 100%;
	width: 100%;
	min-height: inherit;
}

</style>
